/* unplugin-vue-components disabled */import { render } from "./chat-v1.vue?vue&type=template&id=599f9548&scoped=true"
import script from "./chat-v1.vue?vue&type=script&lang=js"
export * from "./chat-v1.vue?vue&type=script&lang=js"

import "./chat-v1.vue?vue&type=style&index=0&id=599f9548&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599f9548"],['__file',"src/pages/chats/chat-v1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "599f9548"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('599f9548', __exports__)) {
    api.reload('599f9548', __exports__)
  }
  
  module.hot.accept("./chat-v1.vue?vue&type=template&id=599f9548&scoped=true", () => {
    api.rerender('599f9548', render)
  })

}


export default __exports__